import { createContext } from "react";
const UserContext = createContext([{ _id: "0000", username: "username" }, () => {}]);
export default UserContext;
